import React from 'react';
import Hero from '../components/Hero';
import AnnouncementBar from '../components/AnnouncementBar';
import FeaturesBar from '../components/FeaturesBar';
import FeaturedCategories from '../components/FeaturedCategories';
import AboutSection from '../components/AboutSection';
import TrustSection from '../components/TrustSection';
import DreamSection from '../components/DreamSection';
import PremiumCollections from '../components/PremiumCollections';
import ServicesShowcase from '../components/ServicesShowcase';
import HomeGallerySection from '../components/HomeGallerySection';
import ProductShowcase from '../components/ProductShowcase';
import FurnishEveryCorner from '../components/FurnishEveryCorner';
import VideoSection from '../components/VideoSection';
import Testimonials from '../components/Testimonials';
import Newsletter from '../components/Newsletter';

const Home = () => {
  return (
    <div>
      <AnnouncementBar />
      <Hero />
      <TrustSection />
      <FeaturesBar />
      <FeaturedCategories />
      <PremiumCollections />
      <AboutSection />
      <DreamSection />
      <ServicesShowcase />
      <HomeGallerySection />
      <ProductShowcase />
      <FurnishEveryCorner />
      <VideoSection />
      <Testimonials />
      <Newsletter />
    </div>
  );
};

export default Home;
